module.exports = __webpack_public_path__ + "img/fridge-icon.af2244d6.svg";